import { Commodity } from '@enmon/commons/lib/shared';
import type { IconProps } from 'components/icon';

export enum CommodityColor {
  Electricity = '#ff5555',
  Water = '#8fcbff',
  Gas = '#85f382',
  Thermal = '#ffc157',
  Other = '#b0b2c4',
}

export const TRANSLATED_COMMODITY: Record<Commodity, string> = {
  [Commodity.Electricity]: 'Electric energy',
  [Commodity.Water]: 'Water',
  [Commodity.NaturalGas]: 'Natural gas',
  [Commodity.Thermal]: 'Thermal',
  [Commodity.Other]: 'Other',
} as const;

export interface CommodityConfigItem {
  iconString: IconProps['iconString'];
  message: string;
  color: CommodityColor;
}

export const COMMODITY_ORDER: Record<Commodity, number> = {
  [Commodity.Electricity]: 1,
  [Commodity.NaturalGas]: 2,
  [Commodity.Thermal]: 3,
  [Commodity.Water]: 4,
  [Commodity.Other]: 5,
};

export const commoditiesConfig: Record<Commodity, CommodityConfigItem> = {
  [Commodity.Electricity]: {
    iconString: 'electricity',
    message: TRANSLATED_COMMODITY[Commodity.Electricity],
    color: CommodityColor.Electricity,
  },
  [Commodity.NaturalGas]: {
    iconString: 'gas',
    message: TRANSLATED_COMMODITY[Commodity.NaturalGas],
    color: CommodityColor.Gas,
  },
  [Commodity.Thermal]: {
    iconString: 'heat',
    message: TRANSLATED_COMMODITY[Commodity.Thermal],
    color: CommodityColor.Thermal,
  },
  [Commodity.Water]: {
    iconString: 'water',
    message: TRANSLATED_COMMODITY[Commodity.Water],
    color: CommodityColor.Water,
  },
  [Commodity.Other]: {
    iconString: 'meteo',
    message: TRANSLATED_COMMODITY[Commodity.Other],
    color: CommodityColor.Other,
  },
};

export const getCommodityIndex = (type: Commodity): number => {
  return COMMODITY_ORDER[type];
};

/**
 * Sorts commodities by their sort index
 * @param a first commodity
 * @param b second commodity
 * @returns -1 if a is before b, 1 if a is after b, 0 if they are equal
 */
export const sortCommodities = (a: Commodity, b: Commodity): number => getCommodityIndex(a) - getCommodityIndex(b);
